import { auth } from '../services/firebase';
import { triggerAuthModal } from './authErrorHandler';

let refreshInterval = null;

export function startTokenRefresh() {
  stopTokenRefresh();
  
  const REFRESH_INTERVAL = 45 * 60 * 1000; // 45 minutes
  
  refreshInterval = setInterval(async () => {
    try {
      const user = auth.currentUser;
      if (!user) return;
      
      await user.getIdToken(true); // force refresh
      console.log('[TokenRefresh] Token refreshed successfully');
    } catch (error) {
      console.error('[TokenRefresh] Failed to refresh token:', error);
      const code = error.code || '';
      
      if (
        code.includes('auth/user-token-expired') ||
        code.includes('auth/user-disabled') ||
        code.includes('auth/invalid-user-token')
      ) {
        triggerAuthModal();
        stopTokenRefresh();
      }
    }
  }, REFRESH_INTERVAL);
}

export function stopTokenRefresh() {
  if (refreshInterval) {
    clearInterval(refreshInterval);
    refreshInterval = null;
  }
}
